import FreeTrialButton from '@/pages/Payment/Components/FreeTrialButton';
import TrialLimitButton from '@/pages/Payment/Components/TrialLimitButton';
import TemplateLibrary from '@components/Templates/TemplateLibrary/TemplateLibrary.component';
import { RouteEnums } from '@Helper/Enums';
import { SubscriptionType, UserGeneralSettings } from '@Helper/Interfaces';
import { Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  getUserDealspaceList,
  postUserDealspaceList,
} from '@Store/feature/dealspaceSlice';
import {
  getUserInfo,
  postIsUserIMO,
  postUserInfo,
} from '@Store/feature/directory';
import { getPricingType } from '@Store/feature/pricingSlice';
import moment from 'moment';
import {
  getPurePlaybookList,
  postPurePlaybookList,
} from '@Store/feature/purePlaybookSlice';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { Icons } from '../../../assets/SvgIcons';
import { RootAssets } from '../../../config/rootAssets';
import { useEffectAsync, UserHelper } from '../../../helper/Infra';
import { LocalStorageHelper } from '../../../helper/LocalStorageHelper';
import { MergefloColors } from '../../../helper/MergefloColors';
import {
  getAssetsFunctionalAreas,
  getAssetsPlaybooks,
  postAssets,
} from '../../../store/feature/assetsSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import Settings from '../Navigation/Settings';
import classes from './Header.module.css';
import { getPlayBookDetail } from '@Store/feature/playBookDetailSlice';
import UserVerify from '@components/UI/UserVerify/UserVerify';
import Spinner from '@components/Spinner';
import AiModal from '@components/UI/AiModal/AiModal';
import TourButton from './tourButton';

export default function Header({ children, headerLeft, headerRight }: any) {
  let userHelper = new UserHelper();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { id, pid } = useParams();
  let navigate = useNavigate();
  const open = Boolean(anchorEl);
  const mergefloColors = new MergefloColors();
  const localStorageHelper = new LocalStorageHelper();
  const [isUserImo, setisUserImo] = useState(false);
  const [inBookShelf, setinBookShelf] = useState(
    document.URL.indexOf('personal-templates') > -1
  );
  const playbooks = useAppSelector(getAssetsPlaybooks);
  const functionalAreas = useAppSelector(getAssetsFunctionalAreas);
  const pricingReducer = useAppSelector(getPricingType);
  const userInfo = useAppSelector(getUserInfo);
  const purePlaybooks = useAppSelector(getPurePlaybookList);
  const currentUser = localStorage.getItem('useremail') ?? '';
  const { userList } = useAppSelector(getPlayBookDetail);
  const [openSettingsModal, setOpenSettingsModal] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    if (purePlaybooks && id && userList) {
      const worksAssetsPlaybooks = purePlaybooks
        ?.filter(
          item => item.functionalArea && item.functionalArea?.isDeleted !== true
        )
        .find(ws => ws.functionalArea?.isIMO === true);

      const userIMO = userList.find(
        user => user.username === currentUser && user.isIMO === true
      );

      if (
        userIMO?.functionalAreaId === worksAssetsPlaybooks?.functionalAreaId
      ) {
        dispatch(postIsUserIMO(true));
        setisUserImo(true);
      } else {
        dispatch(postIsUserIMO(false));
        setisUserImo(false);
      }
    }
  }, [id, purePlaybooks, userList]);

  const logout = async () => {
    const userHelper = new UserHelper();
    await userHelper.logout();
    localStorageHelper.setTaskTray([]);
    localStorage.setItem(userInfo?.username + 'infoSkip', '');
    localStorage.clear();
    navigate(RouteEnums.Login);
    dispatch(
      postAssets({
        dealFunctions: [],
        dealspaces: [],
        invitations: undefined,
        playbooks: [],
        projects: [],
        workspaces: [],
      } as RootAssets)
    );
    dispatch(postPurePlaybookList(undefined));
    dispatch(postUserDealspaceList(undefined));
  };

  const redirectTo = () => {
    if (
      userDealspaceList?.find(
        i =>
          i.id === (id ?? '') &&
          i.trialEndDate &&
          moment(i.trialEndDate).isBefore(moment())
      )?.subscriptionType === SubscriptionType.TRIAL
    ) {
      navigate(RouteEnums.PaymentPlan, { state: { dealspaceId: id } });
    } else {
      navigate(RouteEnums.Subscription + id);
    }
  };
  const redirectToTemplateManagement = async () => {
    if (inBookShelf) {
      const recentUrl = localStorage.getItem('recentUrl');
      console.log('recentUrl', recentUrl);

      if (recentUrl) {
        window.location.href = recentUrl;
      } else {
        navigate(RouteEnums.Login);
      }
    } else {
      localStorage.setItem('recentUrl', window.location.href);
      navigate(RouteEnums.PersonalTemplates);
    }
  };

  const [name, setName] = React.useState('');
  const [surname, setLastName] = React.useState('');
  const userDealspaceList = useAppSelector(getUserDealspaceList) ?? [];

  useEffectAsync(async () => {
    const userResponse =
      (await userHelper.getCurrentUser()) as UserGeneralSettings;
    if (userResponse !== undefined) {
      setName(userResponse.name);
      setLastName(userResponse.surname);
    }
    dispatch(postUserInfo(userResponse));
  }, []);

  const generateAvatar = () => {
    let response = '';
    if (name?.length > 0) response = name[0];
    if (surname?.length) response = response + surname[0];
    return response.length === 0 ? 'NO' : response.toUpperCase();
  };
  const { t } = useTranslation();

  const pricingButton = (type: 'icon' | 'menu' | 'color') => {
    // Trial expired. Subscribe to continue
    if (
      userDealspaceList?.find(
        i =>
          i.id === (id ?? '') &&
          i.trialEndDate &&
          moment(i.trialEndDate).isBefore(moment())
      )?.subscriptionType === SubscriptionType.TRIAL
    ) {
      if (type === 'icon')
        return (
          <Icons.CurrencyExchange color="#FF7452" width="18" height="18" />
        );
      if (type === 'color') return '#FFEBE6';
      else
        return (
          <MenuItem style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TrialLimitButton isUserImo={isUserImo} />
          </MenuItem>
        );
    }

    //Free Trial
    if (
      userDealspaceList?.find(
        i =>
          i.id === (id ?? '') &&
          (!i.trialEndDate || moment(i.trialEndDate).isSameOrAfter(moment()))
      )?.subscriptionType === SubscriptionType.TRIAL
    ) {
      if (type === 'icon') return <Icons.TrialPlanIcon />;
      if (type === 'color') return 'rgba(0, 135, 90, 0.2)';
      else
        return (
          <MenuItem style={{ paddingLeft: 0, paddingRight: 0 }}>
            <FreeTrialButton isUserImo={isUserImo} />
          </MenuItem>
        );
    }

    //Free
    if (
      userDealspaceList?.find(i => i.id === (id ?? ''))?.subscriptionType ===
      SubscriptionType.FREE
    ) {
      if (type === 'icon') return <Icons.Ticket />;
      if (type === 'color') return 'rgba(76, 67, 170, 0.2)';
      else
        return (
          <MenuItem style={{ paddingLeft: 0, paddingRight: 0 }}>
            <button className="free-button">
              <Icons.Ticket />
              <span style={{ marginLeft: 5 }}>Free</span>
            </button>
          </MenuItem>
        );
    }

    //Workstream Pro
    if (
      userDealspaceList?.find(i => i.id === (id ?? ''))?.subscriptionType ===
        SubscriptionType.DEALPLAYBOOK ||
      userDealspaceList?.find(i => i.id === (id ?? ''))?.subscriptionType ===
        SubscriptionType.USERBASEPAID
    ) {
      if (type === 'icon') return <Icons.Polygon />;
      if (type === 'color') return 'rgba(181, 103, 5, 0.2)';
      else
        return (
          <MenuItem style={{ paddingLeft: 0, paddingRight: 0 }}>
            <button className="dealPlaybook-button">
              <Icons.Polygon />
              <span style={{ marginLeft: 5 }}>Workstream Pro</span>
            </button>
          </MenuItem>
        );
    }

    //Subscription Paused
    if (
      userDealspaceList?.find(i => i.id === (id ?? ''))?.subscriptionType ===
      SubscriptionType.SUBSCRIPTION
    ) {
      if (type === 'icon') return <Icons.Pause />;
      if (type === 'color') return '#FFEBE6';
      else
        return (
          <MenuItem style={{ paddingLeft: 0, paddingRight: 0 }}>
            <button className="subscription-button">
              <Icons.Pause />
              <span style={{ marginLeft: 5 }}>Subscription Paused</span>
            </button>
          </MenuItem>
        );
    }

    return <></>;
  };

  function getPmAppName():
    | import('react-i18next').ReactI18NextChild
    | Iterable<import('react-i18next').ReactI18NextChild> {
    if (document.URL.indexOf('personal-template') > -1) {
      return 'Switch to App';
    }
    return t('Switch to Bookshelf');
  }

  const handleOpenSettingsModal = () => {
    setOpenSettingsModal(true);
  };

  return (
    <div className={classes.HeaderContainer}>
      <div className={classes.HeaderContainerTop}>
        <div className="headerLeft">{headerLeft}</div>
        <div className="headerRight">
          {headerRight}
          <TourButton />
          <AiModal
            openAiProps={false}
            fromLayout={false}
            selectedAiModal={undefined}
          />
          {/*<div className="upgrade-message" onClick={() => {}}>
            <Icons.ArrowOutward />
            <div className="upgrade-text" style={{ marginLeft: 3 }}>
              {t('dashboard.switch_to_bookshelf')}
            </div>
          </div>*/}
          {isUserImo &&
            pid &&
            !(
              userDealspaceList?.find(
                i =>
                  i.id === (id ?? '') &&
                  i.trialEndDate &&
                  moment(i.trialEndDate).isBefore(moment())
              )?.subscriptionType === SubscriptionType.TRIAL
            ) && <TemplateLibrary playbookId={pid} />}

          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            className={classes.UserMenu}
            style={{
              background: pricingButton('color') as string,
            }}
          >
            {pricingButton('icon')}

            <div
              style={{ backgroundColor: mergefloColors.getUserColors(name) }}
              className={classes.avatar}
            >
              {generateAvatar() === 'NO' ? <PersonIcon /> : generateAvatar()}
            </div>
          </Button>

          <Menu
            id="account-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            className={classes.accountMenu}
            PaperProps={{
              style: {
                background: '#ffffff',
                border: ' 1px solid #ebebf0',
                boxSizing: 'border-box',
                boxShadow: ' 0px 8px 16px rgba(0, 0, 0, 0.1)',
                borderRadius: 4,
                padding: '8px 8px 6px',
                marginTop: 15,
              },
            }}
          >
            {pricingButton('menu')}
            <MenuItem onClick={redirectToTemplateManagement}>
              <span className="account-menu-icon">
                <Icons.ArrowOutward width="14" height="14" color="#6E6B8C" />
              </span>{' '}
              <span className="account-menu-text">{getPmAppName()}</span>
            </MenuItem>
            {isUserImo &&
              userDealspaceList.find(
                i =>
                  i.dealspaceOwner === (localStorage.getItem('useremail') ?? '')
              ) && (
                <MenuItem onClick={redirectTo}>
                  <span className="account-menu-icon">
                    <Icons.CurrencyExchange
                      width="18"
                      height="18"
                      color="#6E6B8C"
                    />
                  </span>
                  <span className="account-menu-text">Subscription</span>
                </MenuItem>
              )}
            <MenuItem onClick={handleOpenSettingsModal}>
              <span className="account-menu-icon">
                <Icons.Settings color="#6E6B8C" />
              </span>
              <span className="account-menu-text">{t('Settings')}</span>
            </MenuItem>

            <MenuItem
              onClick={() => {
                window.open(
                  'https://www.mergeflo.com/help-docs/help-welcome',
                  '_blank'
                );
              }}
            >
              <span className="account-menu-icon">
                <Icons.HelpOutline />
              </span>
              <span className="account-menu-text">{t('navigation.help')}</span>
            </MenuItem>
            <MenuItem onClick={logout}>
              <span className="account-menu-icon" style={{ paddingLeft: 5 }}>
                <Icons.Logout />
              </span>
              <span className="account-menu-text">{t('dashboard.logout')}</span>
            </MenuItem>
          </Menu>
        </div>
        {children}
      </div>
      <Settings
        openSettingsModal={openSettingsModal}
        setOpenSettingsModal={setOpenSettingsModal}
      />
    </div>
  );
}
